<template>
  <div class="tabs is-large is-main has-margin-bottom-none">
    <ul>
      <router-link
        tag="li"
        v-for="(params, route) in routes"
        v-if="$auth.check(params.roles)"
        :to="{ name: route }"
        :key="route">
        <router-link :to="{ name: route }" v-t="route" />
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SettingsTabs',
  data () {
    return {
      routes: {
        settings: { roles: 'admin' },
        users: { roles: ['admin', 'support'] },
        products: { roles: 'admin' }
      }
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "settings": "Settings",
    "users": "Users",
    "products": "Products"
  },
  "pt-BR": {
    "settings": "Configurações",
    "users": "Usuários",
    "products": "Produtos"
  }
}
</i18n>
